import { RegisterOptions } from 'react-hook-form'

export const registerNumber = (v: string | undefined | null) =>
  v === '' || v === undefined || v === null ? null : Number(v)
// FIXME: RegisterOptions typescript error
export const registerNumberOption = {
  setValueAs: (v: string | undefined | null) => registerNumber(v)
}

export const registerDateOption = {
  setValueAs: (v: string | undefined | null) => (v === '' || v === undefined || v === null ? null : new Date(v))
}
